import { render, staticRenderFns } from "./catalogoProducto.vue?vue&type=template&id=f2d5c93c"
import script from "./catalogoProducto.vue?vue&type=script&lang=js"
export * from "./catalogoProducto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports